// extracted by mini-css-extract-plugin
export default {"composerWrapper":"qEbvhyBNoT"};